import type { CreatureMountSpeedRestrictionInput, CreatureMountSpeedRestrictionResult } from '../types';

export const MOUNT_RESTRICTED_SPEEDS = [
    'walking', 'jumping', 'swimming', 'climbing', 'flying', 'burrowing', 'hovering',
] as const;

/** Replace every non-teleport speed with the mounted/piloted forced-zero wrapper. */
export function restrictCreatureMountedSpeeds(input: CreatureMountSpeedRestrictionInput): CreatureMountSpeedRestrictionResult {
    const restricted = (speed: typeof MOUNT_RESTRICTED_SPEEDS[number]) => {
        const preMount = input.totals[speed] ?? 0;
        return { total: 0 as const, base: 0 as const, locked: true as const, ...(preMount !== 0 ? { pre_mount: preMount } : {}) };
    };
    return {
        walking: restricted('walking'),
        jumping: restricted('jumping'),
        swimming: restricted('swimming'),
        climbing: restricted('climbing'),
        flying: restricted('flying'),
        burrowing: restricted('burrowing'),
        hovering: restricted('hovering'),
    };
}
